import { Route } from 'react-router-dom';
import PageDialplan from '../../pages/raptor/dialplan/dialplan.page';

export const RaptorDiaplan = (
  <>
    <Route path="/dialplan">
      <Route index element={<PageDialplan />} />
    </Route>
  </>
);
